export function Markdown({ text }: { text: string }) {
  return (
    <>
      {text.split("\n").map((line, index) => (
        <p key={`${index}-${line}`}>{line}</p>
      ))}
    </>
  );
}
